const CABLE= 'cable';
const WIFI= 'wifi';
const CELL= 'cellular';
const AQ_GATEWAY= 'aquassistGateway';
const CONNECTION_TYPES = [CABLE, WIFI, CELL, AQ_GATEWAY];
module.exports = {
    CONNECTION_TYPES,
    CABLE,
    WIFI,
    CELL,
    AQ_GATEWAY,
};
